// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__1zu6F","more":"styles_more__Hzqln"};